import constants from "../utils/Constants";
import { getData, postData } from "./rest-api-helper"

export async function sendLoginOtpServ(data) {
    const details = {
        urlPath: "/login",
        body: {
            mail: data.email
        }
    }

    const res = await postData(details);
    return res;
}


export async function verifyLoginOtpServ(data) {
    const details = {
        urlPath: "/login/verifyOTP",
        body: {
            mail: data.email,
            otp: data.otp
        }
    }

    const res = await postData(details);
    return res;
}

